<template>
  <div class="imgBox min-w-1400">
    <div class="imgBox1 min-w-1400">
      <div class="img1 max-w-1400">
        <p class="imgItem1">Thỏa thuận quyền riêng tư</p>
        <!-- <img :src="importedImg1" :alt="altText" class="imgItem1" /> -->
      </div>
    </div>
    <div class="imgBox2 min-w-1400">
      <div class="img2 max-w-1400">
        <!-- <h1>Cam kết bảo mật</h1> -->
        <!-- <div class="title-line"></div> -->
        <div class="textBox" style="white-space: pre-wrap">{{ text }}</div>
      </div>
    </div>
  </div>
</template>

<script>
// import importedImg1 from "@/page/passmorecompany/components/img/4_1.png";

export default {
  data() {
    return {
      altText: "protocolTitle",
      // importedImg1: importedImg1,
      text: `CÔNG TY TNHH KỸ THUẬT CÔNG NGHỆ QUỐC THỊNH (“chúng tôi”) cam kết bảo vệ quyền riêng tư của bạn. Chính sách này giải thích cách chúng tôi thu thập, sử dụng, lưu trữ và bảo vệ thông tin cá nhân của bạn theo các quy định pháp luật hiện hành.

1. Thu thập thông tin
Khi bạn sử dụng dịch vụ của chúng tôi, chúng tôi có thể thu thập các loại thông tin sau:

Thông tin cá nhân: Họ tên, số điện thoại, email, địa chỉ giao hàng
Thông tin giao dịch: Lịch sử mua bán máy tính và phụ kiện, thông tin đơn hàng, thông tin thanh toán
Thông tin thiết bị: Khi bạn truy cập website hoặc ứng dụng của chúng tôi, chúng tôi có thể thu thập thông tin về thiết bị, hệ điều hành, địa chỉ IP, lịch sử duyệt web,…
Hồ sơ liên lạc: Khi bạn liên hệ với bộ phận chăm sóc khách hàng, chúng tôi có thể lưu trữ các cuộc trò chuyện để cải thiện dịch vụ.
2. Mục đích sử dụng thông tin
Chúng tôi sử dụng thông tin thu thập được cho các mục đích sau:

Xử lý đơn hàng: Xác nhận, thanh toán, vận chuyển và hỗ trợ sau bán hàng.
Cải thiện trải nghiệm người dùng: Phân tích hành vi người dùng để nâng cao chất lượng sản phẩm và dịch vụ.
Hỗ trợ khách hàng: Giải quyết vấn đề, khiếu nại và cung cấp hỗ trợ kỹ thuật.
Bảo mật và tuân thủ pháp luật: Ngăn chặn gian lận, bảo vệ quyền lợi người dùng và tuân thủ các quy định pháp luật.

3. Chia sẻ thông tin
Chúng tôi cam kết không bán hoặc chia sẻ thông tin cá nhân của bạn bất hợp pháp. Tuy nhiên, thông tin có thể được chia sẻ trong các trường hợp sau:

Hợp tác kinh doanh: Cung cấp thông tin cần thiết cho các đối tác như đơn vị thanh toán, công ty vận chuyển để hoàn thành giao dịch.
Yêu cầu pháp lý: Khi có yêu cầu từ cơ quan pháp luật hoặc chính phủ, chúng tôi có thể cung cấp thông tin theo quy định.
Bảo vệ quyền lợi: Chia sẻ thông tin để ngăn chặn gian lận, bảo vệ quyền lợi hợp pháp của người dùng và công ty.

4. Lưu trữ và bảo vệ thông tin
Chúng tôi áp dụng các biện pháp kỹ thuật và quản lý để bảo vệ thông tin cá nhân của bạn, bao gồm mã hóa dữ liệu và kiểm soát truy cập. Thông tin của bạn được lưu trữ trên hệ thống bảo mật và chỉ được giữ lại trong khoảng thời gian cần thiết.

5. Quyền lợi của người dùng
Bạn có quyền:
Truy cập, chỉnh sửa hoặc xóa thông tin cá nhân của mình;
Lựa chọn nhận hoặc từ chối các thông tin tiếp thị từ chúng tôi;
Hạn chế hoặc phản đối việc xử lý thông tin cá nhân theo quy định của pháp luật.
Nếu bạn muốn thực hiện các quyền trên, vui lòng liên hệ với chúng tôi qua email: [Nhập email liên hệ].

6. Cookies và công nghệ theo dõi
Chúng tôi có thể sử dụng Cookies để thu thập và lưu trữ dữ liệu truy cập nhằm nâng cao trải nghiệm người dùng. Bạn có thể quản lý quyền sử dụng Cookies trong cài đặt trình duyệt.

7. Cập nhật chính sách quyền riêng tư
Chúng tôi có thể cập nhật chính sách này định kỳ và sẽ thông báo qua website hoặc email nếu có thay đổi quan trọng.

8. Liên hệ chúng tôi
Nếu bạn có bất kỳ câu hỏi hoặc yêu cầu nào liên quan đến quyền riêng tư, vui lòng liên hệ:

Công ty: CÔNG TY TNHH KỸ THUẬT CÔNG NGHỆ QUỐC THỊNH
Email: contact@quocthinhtech.vn
Số điện thoại: +84 2776816281
Vui lòng đọc kỹ chính sách này trước khi sử dụng dịch vụ của chúng tôi và đảm bảo rằng bạn đồng ý với các điều khoản trên.`,
    };
  },
};
</script>

<style scoped>
.imgBox {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
}

.imgBox1 {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  background-color: "";
}

.imgBox2 {
  display: flex;
  justify-content: center;
  max-width: 1400px;
  padding-top: 40px;
  padding-bottom: 20px;
  height: 3700px;
  background-color: #ffffff;
  border-radius: 32px;
  margin: -140px auto 150px;
}

.imgBox3 {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  background-color: "";
}

img {
  display: block;
}

.img1 {
  overflow: hidden;
  width: 100%;
}

.img2,
.img4 {
  overflow: hidden;
}

.img3 {
  width: 100%;
  overflow: hidden;
  margin-left: 0;
  margin-right: 0;
}

.imgItem1 {
  width: 100%;
  margin-top: 0;
  margin-bottom: 0;
}

.imgItem2 {
  max-width: 100%;
}

.imgItem3 {
  width: 100%;
  overflow: hidden;
  margin-left: 0;
  margin-right: 0;
}

h1 {
  margin-top: 50px;
  margin-left: 490px;
  color: #3f4842;
  font-size: 40px;
  /* border-bottom: 5px solid #04358A; */
  display: inline-block;
}

.textBox {
  margin-top: 50px;
  margin-left: 100px;
  margin-right: 100px;
  font-size: 18px;
  color: #333333;
}

.imgBox2 {
  transform: scale(90%);
  /* transform: scale(80%); */
  margin: -50px auto 100px;
  height: 1600px;
  /* box-shadow: 0 1px 4.8px 0px rgba(0, 0, 0, 0.25); */
  border-radius: 12px;
  border: 2px solid #9C67F1;
}
.textBox {
  margin-top: 20px;
  margin-left: 50px;
  margin-right: 50px;
}
/* .imgBox2{
  border-radius: 0;
  border-top: 3px solid #7c2af8;
  border-left: 2px solid #e9e9e9;
  border-right: 2px solid #e9e9e9;
  border-bottom: 3px solid #c1c1c1;
} */
.title-line {
  width: 430px;
  /* background: url(./components/img/Group1.png); */
  /* background-repeat: no-repeat; */
  /* background-position: -150px 10px; */
  /* height: 50px; */
  /* border: 1px solid red; */
  border: 2px solid #4D64E4;
  margin: 0 500px;
}

.img1 {
  /* background: radial-gradient(57.03% 57.03% at 50% 50%, #3C51A0 0%, #223479 100%); */
  height: 291px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.imgItem1 {
  color: #333333;
  font-family: "SF Pro Display";
  font-weight: 700;
  font-size: 34px;
  text-align: center;
}
</style>
